const deliveryData = [
  { pincode: 110001, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110002, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110003, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110004, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110005, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110006, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110007, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110008, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110009, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110010, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110011, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110012, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110013, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110014, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110015, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110016, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110017, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110018, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110019, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110020, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110021, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110022, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110023, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110024, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110025, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110026, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110027, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110028, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110029, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110030, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110031, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110032, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110033, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110034, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110035, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110036, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110037, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110038, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110039, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110040, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110041, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110042, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110043, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110044, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110045, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110046, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110047, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110048, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110049, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110051, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110052, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110053, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110054, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110055, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110056, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110057, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110058, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110059, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110060, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110061, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110062, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110063, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110064, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110065, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110066, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110067, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110068, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110069, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110070, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110071, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110072, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110073, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110074, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110075, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110076, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110077, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110078, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110080, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110081, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110082, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110083, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110084, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110085, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110086, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110087, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110088, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110089, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110090, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110091, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110092, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110093, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110094, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110095, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110096, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 110097, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 122001, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 122002, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 122003, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 122004, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 122005, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 122006, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 122007, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 122008, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 122009, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 122010, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 122011, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 122015, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 122016, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 122017, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 122018, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 122051, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 122052, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 122101, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 122104, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 122105, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 122107, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 122108, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 122413, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 122414, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 122502, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 122503, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 122504, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 122505, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 122506, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 122508, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 123001, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 123021, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 123023, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 123024, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 123027, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 123028, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 123029, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 123034, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 123035, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 123101, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 123102, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 123103, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 123106, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 123110, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 123301, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 123302, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 123303, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 123411, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 123412, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 123501, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 141001, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 141002, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 141003, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 141004, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 141006, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 141007, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 141008, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 141010, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 141012, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 141013, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 141014, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 141015, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 141016, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 141017, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 160001, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 160002, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 160003, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 160004, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 160009, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 160011, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 160012, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 160015, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 160017, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 160018, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 160019, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 160020, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 160022, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 160023, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 160025, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 160030, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 160036, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 160047, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 160101, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 160102, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 180001, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 180002, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 180003, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 180004, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 180005, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 180006, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 180007, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 180009, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 180010, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 201301, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 201303, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 201304, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 201305, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 201306, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 201307, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 201309, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 201310, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 226001, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 226002, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 226003, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 226004, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 226005, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 226006, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 226007, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 226008, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 226009, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 226010, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 226011, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 226012, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 226013, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 226014, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 226015, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 226016, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 226017, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 226018, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 226019, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 226020, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 226021, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 226022, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 226023, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 226024, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 226025, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 226026, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 226027, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 226028, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 226029, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 226030, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 226031, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 263145, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 282001, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 282002, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 282003, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 282004, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 282005, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 282006, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 282007, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 282008, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 282010, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 302001, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 302002, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 302003, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 302004, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 302005, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 302006, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 302012, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 302013, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 302015, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 302016, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 302017, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 302018, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 302019, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 302020, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 302021, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 302022, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 302026, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 302029, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 302031, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 302033, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 302034, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 302036, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 302037, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 302039, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 302040, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 380001, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 380002, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 380004, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 380005, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 380006, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 380007, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 380008, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 380009, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 380013, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 380014, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 380015, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 380016, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 380018, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 380019, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 380021, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 380022, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 380023, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 380024, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 380026, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 380027, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 380028, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 380050, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 380051, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 380052, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 380054, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 380055, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 380058, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 380059, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 380060, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 380061, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 380063, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 382210, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 382330, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 382340, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 382345, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 382350, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 382405, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 382415, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 382418, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 382424, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 382425, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 382427, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 382430, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 382433, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 382435, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 382440, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 382443, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 382475, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 382480, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 394210, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 395001, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 395002, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 395003, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 395004, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 395005, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 395006, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 395007, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 395008, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 395009, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 395010, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 395011, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 395012, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 394101, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 395017, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 400001, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400002, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400003, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400004, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400005, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400006, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400007, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400008, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400009, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400010, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400011, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400012, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400013, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400014, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400015, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400016, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400017, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400018, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400019, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400020, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400021, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400022, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400024, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400025, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400026, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400027, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400028, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400029, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400030, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400031, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400032, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400033, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400034, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400035, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400037, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400042, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400043, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400049, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400050, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400051, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400052, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400053, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400054, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400055, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400056, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400057, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400058, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400059, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400060, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400061, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400063, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400064, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400065, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400066, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400067, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400068, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400069, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400070, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400071, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400072, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400074, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400075, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400076, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400077, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400078, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400079, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400080, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400081, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400082, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400083, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400084, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400085, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400086, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400087, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400088, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400089, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400091, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400092, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400093, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400094, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400095, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400096, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400097, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400098, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400099, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400101, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400102, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400103, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400104, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400601, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400602, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400603, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400604, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400605, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400606, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400607, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400608, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400610, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400612, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400615, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400702, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400704, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400707, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 400710, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 401101, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 401102, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 401103, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 401105, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 401106, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 401107, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 401206, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 403001, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 403002, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 403004, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 403005, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 403006, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 403102, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 403104, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 403108, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 403109, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 403110, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 403115, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 403201, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 403202, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 403203, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 403204, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 403206, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 403521, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 410206, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 410207, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 410208, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 410210, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 410218, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 410221, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 411001, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 411002, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 411003, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 411004, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 411005, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 411006, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 411007, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 411008, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 411009, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 411011, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 411012, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 411013, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 411014, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 411015, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 411016, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 411017, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 411020, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 411021, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 411022, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 411023, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 411024, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 411028, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 411030, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 411031, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 411032, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 411033, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 411034, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 411035, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 411036, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 411037, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 411038, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 411039, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 411040, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 411041, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 411042, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 411043, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 411044, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 411045, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 411046, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 411047, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 411048, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 411051, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 411052, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 411058, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 411060, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 411061, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 411062, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 421101, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 421102, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 421103, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 421301, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 421302, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 421305, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 421306, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 421308, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 421311, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 421605, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 440001, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 440002, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 440003, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 440005, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 440006, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 440007, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 440008, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 440010, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 440012, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 440013, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 440014, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 440015, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 440016, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 440017, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 440018, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 440019, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 440020, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 440021, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 440022, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 440023, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 440024, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 440025, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 440026, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 440027, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 440030, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 440032, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 440033, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 440034, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 440035, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 440036, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 440037, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 452001, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 452002, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 452003, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 452005, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 452006, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 452007, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 452009, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 452010, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 452011, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 452012, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 452013, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 452014, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 452015, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 452016, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 452018, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 462001, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 462002, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 462003, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 462004, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 462007, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 462008, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 462010, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 462011, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 462013, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 462016, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 462020, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 462022, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 462023, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 462024, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 462026, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 462027, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 462030, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 462031, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 492001, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 492002, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 492003, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 492004, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 492005, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 492008, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 492009, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 492010, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 492012, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 492013, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 492014, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 492015, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 500001, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500002, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500003, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500004, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500005, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500006, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500007, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500008, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500009, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500010, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500011, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500012, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500013, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500014, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500015, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500016, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500017, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500018, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500019, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500020, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500022, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500023, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500024, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500025, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500026, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500027, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500028, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500029, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500030, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500031, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500032, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500033, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500034, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500035, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500036, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500037, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500038, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500039, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500040, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500041, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500042, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500043, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500044, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500045, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500046, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500047, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500048, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500049, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500050, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500051, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500052, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500053, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500054, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500055, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500056, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500057, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500058, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500059, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500060, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500061, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500062, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500063, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500064, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500065, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500066, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500067, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500068, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500069, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500070, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500072, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500073, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500074, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500075, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500076, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500077, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500078, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500079, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500080, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500081, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500082, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500083, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500084, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500085, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500086, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500087, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500088, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500089, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500090, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500091, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500092, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500093, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500094, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500095, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500096, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500097, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500098, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500100, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 500101, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 501101, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 501102, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 501106, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 501111, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 501121, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 501141, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 501142, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 501143, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 501144, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 501158, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 501202, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 501203, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 501218, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 501301, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 501359, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 501401, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 501501, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 501502, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 501503, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 501504, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 501505, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 501506, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 501508, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 501509, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 501510, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 501511, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 501512, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 520001, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 520002, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 520003, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 520004, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 520007, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 520008, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 520010, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 520011, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 520012, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 520013, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 520015, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 530001, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 530002, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 530003, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 530004, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 530005, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 530007, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 530008, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 530009, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 530011, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 530012, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 530013, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 530014, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 530015, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 530016, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 530017, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 530018, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 530020, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 530022, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 530024, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 530026, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 530027, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 530028, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 530029, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 530031, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 530032, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 530035, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 530040, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 530041, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 530043, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 530044, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 530045, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 530046, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 530047, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 530048, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 530049, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 530051, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 530052, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 530053, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 560001, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560002, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560003, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560004, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560005, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560006, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560007, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560008, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560009, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560010, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560011, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560012, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560013, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560014, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560015, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560016, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560017, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560018, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560019, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560020, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560021, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560022, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560023, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560024, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560025, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560026, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560027, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560029, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560030, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560032, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560033, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560034, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560035, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560036, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560037, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560038, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560039, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560040, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560041, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560042, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560043, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560045, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560046, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560047, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560048, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560049, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560050, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560051, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560053, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560054, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560055, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560056, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560057, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560058, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560059, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560060, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560061, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560062, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560063, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560064, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560065, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560066, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560067, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560068, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560070, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560071, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560072, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560073, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560074, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560075, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560076, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560077, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560078, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560079, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560080, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560081, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560082, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560083, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560084, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560085, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560086, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560087, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560088, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560089, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560090, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560091, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560092, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560093, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560094, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560095, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560096, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560097, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560098, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560099, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560100, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560102, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560103, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560104, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560105, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560107, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560108, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560109, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560110, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 560300, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 561101, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 561201, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 561203, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 561204, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 561205, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 562106, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 562107, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 562108, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 562109, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 562110, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 562111, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 562112, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 562114, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 562119, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 562120, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 562121, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 562122, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 562123, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 562125, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 562126, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 562127, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 562128, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 562129, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 562130, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 562131, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 562132, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 562135, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 562138, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 562149, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 562157, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 562161, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 562162, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 562163, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 575001, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 575002, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 575003, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 575004, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 575005, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 575006, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 575007, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 575008, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 575010, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 575011, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 575013, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 575014, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 575015, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 575016, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 575017, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 575018, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 575019, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 575020, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 600001, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600002, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600003, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600004, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600005, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600006, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600007, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600008, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600009, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600010, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600011, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600012, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600013, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600014, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600015, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600016, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600017, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600018, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600019, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600020, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600021, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600022, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600023, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600024, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600025, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600026, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600028, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600029, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600030, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600031, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600032, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600033, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600034, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600035, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600036, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600037, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600038, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600039, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600040, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600041, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600042, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600043, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600044, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600045, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600046, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600047, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600048, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600049, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600050, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600051, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600052, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600053, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600054, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600055, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600056, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600057, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600058, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600059, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600060, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600061, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600062, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600063, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600064, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600065, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600066, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600067, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600068, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600069, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600070, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600071, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600072, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600073, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600074, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600075, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600076, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600077, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600078, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600081, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600082, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600083, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600084, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600085, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600086, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600087, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600088, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600089, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600090, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600091, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600092, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600093, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600094, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600095, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600096, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600097, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600098, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600099, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600100, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600101, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600102, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600103, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600104, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600106, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600107, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600110, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600113, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600115, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600116, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600117, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600118, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600119, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600120, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600122, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600123, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600124, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600125, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600126, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600127, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600128, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600129, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 600130, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 601101, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 601202, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 601204, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 601205, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 601206, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 601301, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 603101, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 603103, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 603104, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 603105, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 603106, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 603107, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 603108, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 603109, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 603110, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 603111, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 603112, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 603127, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 603201, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 603203, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 603204, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 603209, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 603210, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 603211, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 603301, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 603303, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 603305, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 603306, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 603307, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 603308, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 603309, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 603310, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 603311, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 603312, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 603313, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 603314, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 603319, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 603401, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 603405, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 625001, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 625002, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 625003, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 625004, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 625005, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 625006, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 625007, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 625008, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 625009, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 625011, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 625012, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 625014, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 625015, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 625016, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 625017, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 625018, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 625020, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 635109, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 635126, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 636001, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 636002, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 636003, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 636004, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 636005, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 636006, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 636007, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 636008, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 636009, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 636010, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 636011, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 636012, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 636013, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 636014, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 636015, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 636016, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 636030, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 641001, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 641002, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 641003, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 641004, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 641005, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 641006, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 641007, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 641008, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 641009, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 641010, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 641011, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 641012, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 641013, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 641014, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 641015, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 641018, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 641019, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 641020, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 641023, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 641024, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 641025, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 641027, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 641028, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 641029, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 641030, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 641037, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 682011, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 682012, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 682013, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 682015, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 682016, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 682017, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 682018, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 682019, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 682020, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 682301, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 682304, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 682306, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 682307, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 682309, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 682504, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 682505, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 682507, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 682508, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 682511, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 683572, serviceable: "Yes", tier: "TIER 3" },
  { pincode: 700001, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700002, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700003, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700004, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700005, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700006, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700007, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700008, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700009, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700010, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700011, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700012, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700013, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700014, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700015, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700016, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700017, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700018, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700019, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700020, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700021, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700022, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700023, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700024, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700025, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700026, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700027, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700028, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700029, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700030, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700031, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700032, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700033, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700034, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700035, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700036, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700037, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700038, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700039, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700040, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700041, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700042, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700043, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700044, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700045, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700046, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700047, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700048, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700049, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700050, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700051, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700052, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700053, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700054, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700055, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700056, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700057, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700058, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700059, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700060, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700061, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700062, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700063, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700064, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700065, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700066, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700067, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700068, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700069, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700070, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700071, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700072, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700073, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700074, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700075, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700076, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700077, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700078, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700079, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700080, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700081, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700082, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700083, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700084, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700085, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700086, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700087, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700088, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700089, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700090, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700091, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700092, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700093, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700094, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700095, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700096, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700097, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700098, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700099, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700100, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700101, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700102, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700105, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700106, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700107, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700108, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700156, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700157, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 700159, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 711101, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 711102, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 711103, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 711104, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 711105, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 711106, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 711107, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 711108, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 711109, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 711110, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 711111, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 711112, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 711113, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 711114, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 711201, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 711202, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 711203, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 711204, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 711205, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 711225, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 711226, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 711227, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 711301, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 711302, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 711303, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 711304, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 711305, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 711306, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 711307, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 711308, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 711309, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 711310, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 711312, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 711313, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 711314, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 711315, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 711316, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 711317, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 711322, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 711401, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 711403, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 711404, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 711405, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 711408, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 711409, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 711410, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 711411, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 711412, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 711413, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 711414, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 712246, serviceable: "Yes", tier: "TIER 1" },
  { pincode: 734001, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 734003, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 734004, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 734010, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 751001, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 751002, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 751003, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 751004, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 751005, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 751006, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 751007, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 751008, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 751009, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 751010, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 751011, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 751012, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 751013, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 751014, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 751015, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 751016, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 751017, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 751018, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 751019, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 751020, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 751021, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 751022, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 751023, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 751024, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 751025, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 751030, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 781001, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 781003, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 781004, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 781005, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 781006, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 781007, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 781008, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 781009, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 781010, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 781011, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 781012, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 781013, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 781014, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 781016, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 781017, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 781018, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 781019, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 781020, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 781021, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 781022, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 781023, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 781024, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 781025, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 781026, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 781027, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 781028, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 781029, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 781031, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 781032, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 781034, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 781035, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 781036, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 781037, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 781038, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 781039, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 781040, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 781171, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 800001, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 800002, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 800003, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 800004, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 800005, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 800006, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 800007, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 800008, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 800009, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 800010, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 800011, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 800012, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 800013, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 800014, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 800015, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 800016, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 800017, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 800018, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 800019, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 800020, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 800021, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 800022, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 800023, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 800024, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 800025, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 800026, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 800027, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 800028, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 800029, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 834001, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 834002, serviceable: "Yes", tier: "TIER 2" },
  { pincode: 834003, serviceable: "Yes", tier: "TIER 2" },
];